import { connect } from 'react-redux';
import JournalistsPage from '../components/journalistsPageComponent';
import { getJournalistsData } from '../actions/journalistsActions';

const mapStateToProps = (state) => ({
    journalistsData: state.journalists.journalistsData,
    isLoadingData: state.journalists.isLoadingData,
});
const mapDispatchToProps = (dispatch) => ({
    getJournalistsData: (slug) => {
        dispatch(getJournalistsData(slug));
    },
});
const JournalistsPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(JournalistsPage);

export default JournalistsPageContainer;
